export default {
  correlativas: {},
  correlativass: [],
  fields: {},
  errorArray: [],
  dialog: false,
};
